import type { ApiKey, LoadStatus, SaveStatus } from '../../_shared/domain/api-key.model';
import {
  type ApiKeyDraft,
  emptyDraft,
  type ValidationErrors,
} from '../domain/api-key-draft.model';
import type { EditApiKeyError } from '../domain/edit-api-key-error';

/**
 * Redux state for the Edit API key form: the loaded key (for the header +
 * disabled prefix field), the editable draft, the load + save lifecycles, and
 * the current validation / transport error. Every field is serialisable.
 */
export interface EditApiKeyState {
  /** The key being edited (null until loaded / when not found). */
  apiKey: ApiKey | null;
  draft: ApiKeyDraft;
  loadStatus: LoadStatus;
  saveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: EditApiKeyError | null;
}

export const initialState: EditApiKeyState = {
  apiKey: null,
  draft: emptyDraft,
  loadStatus: 'idle',
  saveStatus: 'idle',
  validationErrors: {},
  error: null,
};
